import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00A99D",
    },

    error: {
      main: "#fd6a67",
    },
    success: {
      main: "#a1c560",
    },
  },
});

export default theme;